(() => {
  const CLOSE_DELAY = 420;

  document.querySelectorAll('.apex-nav').forEach((nav) => {
    if (nav.dataset.hoverIntentReady === 'true') return;
    nav.dataset.hoverIntentReady = 'true';
    const items = [...nav.querySelectorAll('.apex-nav__item--mega')];
    let closeTimer;
    let activeItem = null;
    const topLink = (item) => item.querySelector(':scope > .apex-nav__top');
    const cancelClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    };
    const close = (item = activeItem) => {
      if (!item) return;
      item.classList.remove('is-mega-open');
      topLink(item)?.setAttribute('aria-expanded', 'false');
      if (activeItem === item) activeItem = null;
    };
    const open = (item) => {
      cancelClose();
      if (activeItem && activeItem !== item) close(activeItem);
      activeItem = item;
      item.classList.add('is-mega-open');
      topLink(item)?.setAttribute('aria-expanded', 'true');
    };
    const scheduleClose = (item) => {
      cancelClose();
      closeTimer = window.setTimeout(() => close(item), CLOSE_DELAY);
    };

    items.forEach((item) => {
      const link = topLink(item);
      link?.setAttribute('aria-haspopup', 'true');
      link?.setAttribute('aria-expanded', 'false');
      item.addEventListener('pointerenter', () => open(item));
      item.addEventListener('pointerleave', () => scheduleClose(item));
      item.addEventListener('focusin', () => open(item));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) scheduleClose(item);
      });
    });

    nav.addEventListener('pointerenter', cancelClose);
    nav.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !activeItem) return;
      event.preventDefault();
      const link = topLink(activeItem);
      close(activeItem);
      link?.focus();
    });
  });
})();
